// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Liberate brand red — global tokens & Bootstrap danger alignment */
:root {
  --brand-red: #b32025;
  --brand-red-dark: #8f1a1e;
  --brand-red-light: #d4282e;
  --brand-red-soft: rgba(179, 32, 37, 0.1);
  --brand-red-border: rgba(179, 32, 37, 0.22);
  --brand-purple-accent: #7c3aed;
  --brand-purple-deep: #6d28d9;
}

.text-danger {
  color: var(--brand-red) !important;
}

.bg-danger {
  background-color: var(--brand-red) !important;
}

.border-danger {
  border-color: var(--brand-red) !important;
}

.btn-danger {
  background-color: var(--brand-red) !important;
  border-color: var(--brand-red) !important;
}

.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active {
  background-color: var(--brand-red-dark) !important;
  border-color: var(--brand-red-dark) !important;
}

.btn-outline-danger {
  color: var(--brand-red) !important;
  border-color: var(--brand-red) !important;
}

.btn-outline-danger:hover,
.btn-outline-danger:focus,
.btn-outline-danger:active {
  background-color: var(--brand-red) !important;
  border-color: var(--brand-red) !important;
  color: #ffffff !important;
}

.alert-danger {
  --bs-alert-color: var(--brand-red-dark);
  --bs-alert-bg: var(--brand-red-soft);
  --bs-alert-border-color: var(--brand-red-border);
}

.form-control.is-invalid,
.form-select.is-invalid {
  border-color: var(--brand-red) !important;
}

.invalid-feedback {
  color: var(--brand-red) !important;
}

.spinner-border.text-danger {
  color: var(--brand-red) !important;
}

.badge.bg-danger {
  background-color: var(--brand-red) !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/brand-colors.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;EACE,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,wCAAwC;EACxC,2CAA2C;EAC3C,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;;;EAGE,kDAAkD;EAClD,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;;;EAGE,6CAA6C;EAC7C,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":["/* Liberate brand red — global tokens & Bootstrap danger alignment */\n:root {\n  --brand-red: #b32025;\n  --brand-red-dark: #8f1a1e;\n  --brand-red-light: #d4282e;\n  --brand-red-soft: rgba(179, 32, 37, 0.1);\n  --brand-red-border: rgba(179, 32, 37, 0.22);\n  --brand-purple-accent: #7c3aed;\n  --brand-purple-deep: #6d28d9;\n}\n\n.text-danger {\n  color: var(--brand-red) !important;\n}\n\n.bg-danger {\n  background-color: var(--brand-red) !important;\n}\n\n.border-danger {\n  border-color: var(--brand-red) !important;\n}\n\n.btn-danger {\n  background-color: var(--brand-red) !important;\n  border-color: var(--brand-red) !important;\n}\n\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger:active {\n  background-color: var(--brand-red-dark) !important;\n  border-color: var(--brand-red-dark) !important;\n}\n\n.btn-outline-danger {\n  color: var(--brand-red) !important;\n  border-color: var(--brand-red) !important;\n}\n\n.btn-outline-danger:hover,\n.btn-outline-danger:focus,\n.btn-outline-danger:active {\n  background-color: var(--brand-red) !important;\n  border-color: var(--brand-red) !important;\n  color: #ffffff !important;\n}\n\n.alert-danger {\n  --bs-alert-color: var(--brand-red-dark);\n  --bs-alert-bg: var(--brand-red-soft);\n  --bs-alert-border-color: var(--brand-red-border);\n}\n\n.form-control.is-invalid,\n.form-select.is-invalid {\n  border-color: var(--brand-red) !important;\n}\n\n.invalid-feedback {\n  color: var(--brand-red) !important;\n}\n\n.spinner-border.text-danger {\n  color: var(--brand-red) !important;\n}\n\n.badge.bg-danger {\n  background-color: var(--brand-red) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
